var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.38413 9.6737C4.38402 8.168 4.70692 6.67969 5.33118 5.3086C5.95544 3.93752 6.86663 2.71536 8.00361 1.72412H7.97475C5.85972 1.72412 3.83131 2.56166 2.33575 4.0525C0.840195 5.54334 0 7.56534 0 9.6737C0 11.7821 0.840195 13.8041 2.33575 15.2949C3.83131 16.7857 5.85972 17.6233 7.97475 17.6233H8.00361C6.86663 16.632 5.95544 15.4099 5.33118 14.0388C4.70692 12.6677 4.38402 11.1794 4.38413 9.6737Z",
    fill: "url(#paint0_linear_175_2432)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4156 16.8123C13.8807 16.8123 15.8791 13.6161 15.8791 9.67347C15.8791 5.73082 13.8807 2.53467 11.4156 2.53467C8.95052 2.53467 6.95215 5.73082 6.95215 9.67347C6.95215 13.6161 8.95052 16.8123 11.4156 16.8123Z",
    fill: "url(#paint1_linear_175_2432)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9992 1.67188C13.4219 1.67188 11.8801 2.13811 10.5686 3.01162C9.25719 3.88513 8.23505 5.12669 7.63146 6.57928C7.02787 8.03188 6.86994 9.63027 7.17765 11.1723C7.48536 12.7144 8.24488 14.1309 9.36017 15.2427C10.4755 16.3544 11.8964 17.1115 13.4434 17.4183C14.9903 17.725 16.5938 17.5676 18.051 16.9659C19.5082 16.3642 20.7537 15.3453 21.6299 14.038C22.5062 12.7307 22.9739 11.1937 22.9739 9.62145C22.9739 8.5775 22.7676 7.54377 22.3669 6.57928C21.9661 5.61479 21.3787 4.73844 20.6382 4.00025C19.8976 3.26207 19.0185 2.6765 18.051 2.277C17.0834 1.8775 16.0464 1.67187 14.9992 1.67188ZM14.3608 16.4672C13.0024 16.4676 11.6745 16.0664 10.5449 15.3144C9.41533 14.5624 8.53483 13.4933 8.01478 12.2425C7.49472 10.9916 7.35846 9.61508 7.62324 8.28701C7.88802 6.95894 8.54194 5.73898 9.5023 4.7814C10.4627 3.82382 11.6863 3.17165 13.0185 2.90735C14.3507 2.64306 15.7316 2.77853 16.9866 3.29661C18.2416 3.8147 19.3142 4.69214 20.0689 5.81796C20.8236 6.94378 21.2264 8.26741 21.2264 9.62145C21.2264 11.4368 20.5031 13.1777 19.2156 14.4615C17.9281 15.7453 16.1818 16.4667 14.3608 16.4672Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_175_2432",
    x1: 0,
    y1: 9.6737,
    x2: 8.00361,
    y2: 9.6737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC0D15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9E1510"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_175_2432",
    x1: 351.086,
    y1: 770.813,
    x2: 792.971,
    y2: 770.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC0D15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#9E1510"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.312c460496f8ada524d00cc9b2bdd3a4.svg";
export { ForwardRef as ReactComponent };